const hobbyTabIds = {
  movies: 1,
  music: 2,
  videoGames: 3
}

export {
  hobbyTabIds
}